import { APICore } from './apiCore'

const api = new APICore()

function getActiveOffices () {
  const baseUrl = '/dashboard/active-offices'
  return api.get(baseUrl, {})
}
function getRegisteredVisits () {
  const baseUrl = '/dashboard/registered-visits'
  return api.get(baseUrl, {})
}
function getVisitsByCountry () {
  const baseUrl = '/dashboard/visits-by-country'
  return api.get(baseUrl, {})
}
function getVisitsByRegion () {
  const baseUrl = '/dashboard/visits-by-region'
  return api.get(baseUrl, {})
}
function getInfoSended () {
  const baseUrl = '/dashboard/info-sended'
  return api.get(baseUrl, {})
}

export { getActiveOffices, getRegisteredVisits, getVisitsByCountry, getVisitsByRegion, getInfoSended }
